import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfCodeBlock = React.memo(({ node }: AdfNodeProps) => {
    const language = node.attrs?.language || 'text';
    const codeText = node.content?.map(textNode => textNode.text).join('') || '';

    return (
        <div className="code-block">
            <pre>
                <code className={`language-${language}`}>
                    {codeText}
                </code>
            </pre>
        </div>
    );
});
